import { ButtonGroup } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../contentConstants';
import { InstructionsContainer, InstructionsText, InstructionsTitle } from '../common/styles/globalStyles';
import { AddAudienceButton } from './AddAudienceButton';
import { AudienceMode } from './AudienceMode';

export const ContentContainer = styled.div`
	text-align: center;
	position: relative;
	margin-top: 125px;
	margin-bottom: 105px @media (min-width: 0) and (max-width: 768px) {
		margin-top: 105px;
		margin-bottom: 85px;
	}
`;
ContentContainer.displayName = 'ContentContainer';

const AudienceButtonContainer = styled(ButtonGroup)`
	position: relative;
`;
AudienceButtonContainer.displayName = 'AudienceButtonContainer';

export interface INoAudienceProps {
	surveyId: number;
}

export class NoAudience extends React.Component<INoAudienceProps, {}> {
	constructor(props: INoAudienceProps) {
		super(props);
	}

	public render() {
		return (
			<>
				<ContentContainer>
					<InstructionsContainer>
						<InstructionsTitle>{ContentConstants.AUDIENCELIST_NOAUDIENCE_INSTRUCTIONSTITLE}</InstructionsTitle>
						<InstructionsText>{ContentConstants.AUDIENCELIST_NOAUDIENCE_INSTRUCTIONSTEXT}</InstructionsText>
					</InstructionsContainer>
					<AudienceButtonContainer>
						<AddAudienceButton surveyId={this.props.surveyId} mode={AudienceMode.Edit} dropdownPositionX={0} dropdownPositionY={40} />
					</AudienceButtonContainer>
				</ContentContainer>
			</>
		);
	}
}
